import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CakeItemVariant } from '../cake-item-variant';

/** Card of a product built in the cake builder: sizes / photo info and "Order now" on hover, or the cart controls. */
@Component({
  standalone: true,
  selector: 'cake-item-complex',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, NgTemplateOutlet, RouterLink, TranslateModule],
  templateUrl: './cake-item-complex.component.html',
})
export class CakeItemComplexComponent extends CakeItemVariant {
  cartCount = input(0);
  /** touch: the controls were revealed by a first tap */
  controlsVisible = input(false);
  /** touch with the product in the cart: the overlay takes no taps until the controls are revealed */
  touchLocked = input(false);

  open = output<void>();
  edit = output<void>();
  remove = output<void>();
}
